import React from 'react';
import { LayoutGrid, Package, Boxes } from 'lucide-react';
import { TabBar } from '../../components/ui';

const TABS = [
  { id: 'overview', label: 'Overview', to: '/dashboard/assets', icon: LayoutGrid },
  { id: 'fixed', label: 'Fixed Assets', to: '/dashboard/assets/fixed', icon: Package },
  { id: 'inventory', label: 'Inventory', to: '/dashboard/assets/inventory', icon: Boxes },
];

/** Asset Management tab strip — Overview / Fixed Assets / Inventory. */
export default function AssetTabs({ active }) {
  return <TabBar tabs={TABS} active={active} ariaLabel="Asset management sections" />;
}
